<template>
	<header class="header">
		<Nav></Nav>
		<div class="content">
			<h3>全行业 · 一站式小程序开发</h3>
			<p>现场一对一服务 &nbsp | &nbsp 深度契合行业需求</p>
			<!-- <button @click="toConsult">小程序需求免费评估</button> -->
			<a onclick="openZoosUrl('chatwin')">小程序需求免费评估</a>

		</div>
		<div class="ability">
			<div @mouseover="mousepiaofu(1)" :class="{ piaofu: pfstatus == 1 }">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/100.png" alt="" />
				<p>百人技术团队</p>
			</div>
			<div @mouseover="mousepiaofu(2)" :class="{ piaofu: pfstatus == 2 }">
				<img src="../../views/static/15.png" alt="" />
				<p>15年定制经验</p>
			</div>
			<div @mouseover="mousepiaofu(3)" :class="{ piaofu: pfstatus == 3 }">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/500.png" alt="" />
				<p>500强企业放心之选</p>
			</div>
			<div @mouseover="mousepiaofu(4)" :class="{ piaofu: pfstatus == 4 }">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/3.png" alt="" />
				<p>3地协同办公</p>
			</div>
		</div>
	</header>
	<div class="serve1">
		<h3>为企业提供一站式技术服务，以高品质铸造商业价值</h3>

		<div class="card">
			<img class="card-bg" src="../../assets/home_icon/bg.png" alt="">
			<div class="item">
				<img src="../../assets/home_icon/1.png" alt="">
				<h5>电商</h5>
				<span>BTB</span>
				<span>BTC</span>
				<span>CTB</span>
			</div>
			<div class="item">
				<img src="../../assets/home_icon/2.png" alt="">
				<h5>教育</h5>
				<span>解题</span>
				<span>考试</span>
				<span>分析</span>
			</div>
			<div class="item">
				<img src="../../assets/home_icon/3.png" alt="">
				<h5>商业、物业</h5>
				<span>购物</span>
				<span>娱乐</span>
				<span>服务</span>
			</div>
			<div class="item">
				<img src="../../assets/home_icon/4.png" alt="">
				<h5>医疗健康</h5>
				<span>抓药</span>
				<span>问诊</span>
				<span>挂号</span>
			</div>
			<div class="item">
				<img src="../../assets/home_icon/5.png" alt="">
				<h5>企业应用</h5>
				<span>ERP</span>
				<span>商家</span>
				<span>品牌</span>
			</div>
			<div class="item">
				<img src="../../assets/home_icon/6.png" alt="">
				<h5>展示推广</h5>
				<span>分享</span>
				<span>宣传</span>
				<span>帖子</span>
			</div>
			<div class="item">
				<img src="../../assets/home_icon/7.png" alt="">
				<h5>家政服务</h5>
				<span>维修</span>
				<span>保洁</span>
				<span>搬家</span>
			</div>
			<div class="item">
				<img src="../../assets/home_icon/8.png" alt="">
				<h5>消防设备</h5>
				<span>器材</span>
				<span>店铺</span>
				<span>区域</span>
			</div>
			<div class="item">
				<img src="../../assets/home_icon/9.png" alt="">
				<h5>政府</h5>
				<span>审批</span>
				<span>OA</span>
				<span>流程</span>
			</div>
			<div class="item">
				<img src="../../assets/home_icon/10.png" alt="">
				<h5>大企业</h5>
				<span>会议</span>
				<span>管理</span>
				<span>程序</span>
			</div>
			<div class="item">
				<img src="../../assets/home_icon/11.png" alt="">
				<h5>智慧社区</h5>
				<span>住宅</span>
				<span>区域</span>
				<span>定位</span>
			</div>
			<div class="item">
				<img src="../../assets/home_icon/12.png" alt="">
				<h5>更多...</h5>
				<span>定制</span>
				<span>专业</span>
				<span>品质</span>
			</div>
		</div>
		<!-- 		<div class="content">
			<div class="left">
				<h4>可靠、安全的专业UED团队全行业·一站式小程序开发</h4>
				<p>· 十余年开发经验,数千项案例</p>
				<p>· 业务能力辐射全行业</p>
				<p>· 一对一定制小程序开发模式</p>
				<div class="more" @click="toConsult">查看更多</div>
				
				<a onclick="openZoosUrl('chatwin')" class="more">查看更多</a>
				
			</div>
			<div class="right">
				<div class="box" @mouseover="mouseOver(1)" @mouseleave="mouseLeave">
					<img v-if="isImgShow && index == 1"
						src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/bao.png" alt="" />
					<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/dainshang01.png"
						alt="" />
					<div class="dians">
						<h5>电商小程序</h5>
						<span>B2B</span>
						<span>B2C</span>
						<span>C2B</span>
					</div>
				</div>

				<div class="box" @mouseover="mouseOver(2)" @mouseleave="mouseLeave">
					<img v-if="isImgShow && index == 2"
						src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/jiaoyu.png" alt="" />
					<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/jiaoyu01.png" alt="" />
					<div class="dians">
						<h5>教育小程序</h5>
						<span>解题</span>
						<span>考试</span>
						<span>早教</span>
						<span>更多</span>
					</div>
				</div>

				<div class="box" @mouseover="mouseOver(3)" @mouseleave="mouseLeave">
					<img v-if="isImgShow && index == 3"
						src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/qiye.png" alt="" />
					<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/qiye01.png" alt="" />
					<div class="dians">
						<h5>企业应用</h5>
						<span>OA</span>
						<span>CRM</span>
						<span>ERP</span>
						<span>更多</span>
					</div>
				</div>

				<div class="box" @mouseover="mouseOver(4)" @mouseleave="mouseLeave">
					<img v-if="isImgShow && index == 4"
						src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/pingtai.png" alt="" />
					<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/pingtai01.png" alt="" />
					<div class="dians">
						<h5>O2O平台</h5>
						<span>生鲜</span>
						<span>餐饮</span>
						<span>同城</span>
						<span>更多</span>
					</div>
				</div>

				<div class="box" @mouseover="mouseOver(5)" @mouseleave="mouseLeave">
					<img v-if="isImgShow && index == 5"
						src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/zhibo.png" alt="" />
					<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/zhibo01.png" alt="" />
					<div class="dians">
						<h5>直播小程序</h5>
						<span>带货</span>
						<span>娱乐</span>
						<span>教育</span>
						<span>更多</span>
					</div>
				</div>

				<div class="box" @mouseover="mouseOver(6)" @mouseleave="mouseLeave">
					<img v-if="isImgShow && index == 6"
						src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/shejiao.png" alt="" />
					<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/shejiao01.png" alt="" />
					<div class="dians">
						<h5>社交小程序</h5>
						<span>聊天</span>
						<span>交友</span>
						<span>C2C</span>
						<span>社群</span>
					</div>
				</div>
			</div>
		</div> -->
	</div>
	<div class="major">
		<h2>多行业解决方案，一对一专项服务</h2>
		<div class="content" ref="Box" @mousewheel="scroll">
			<!-- swiper -->
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide">
						<div class="ban1">
							<h3>政府&大企业</h3>
							<p class="heng"></p>
							<p>政府管理程序、企业运输登记</p>
						</div>
					</div>
					<div class="swiper-slide">
						<div class="ban2">
							<h3>医疗</h3>
							<div class="heng"></div>
							<p>线上预约问诊、医护人员管理分配</p>
						</div>
					</div>
					<div class="swiper-slide">
						<div class="ban3">
							<h3>电商</h3>
							<p class="heng"></p>
							<p>社交电商\零售解决方案</p>
						</div>
					</div>
					<div class="swiper-slide">
						<div class="ban4">
							<h3>地产</h3>
							<p class="heng"></p>
							<p>助力房地产营销推广开流</p>
						</div>
					</div>
				</div>

				<!-- 如果需要导航按钮 -->
				<div class="swiper-button-prev"></div>
				<div class="swiper-button-next"></div>
				<!-- <div class="swiper-pagination1"></div> -->
			</div>
		</div>
	</div>
	<div class="skill">
		<div class="content">
			<h3>领先的技术平台</h3>
			<p>稳定，开源，可迭代—为企业提供可靠的互联网技术服务</p>
			<!-- <button @click="toConsult">查看详情</button> -->

			<a onclick="openZoosUrl('chatwin')">查看详情</a>

			<div class="buttom">
				<div>
					<div class="top">
						<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/daima.png" alt="" />
						<h4>开源代码交付</h4>
					</div>
					<p>· 可迭代开发，代码开源无加密</p>
					<p>· PHP、JAVA双团队，更多灵活选择</p>
					<p>· 团队易上手</p>
					<p>· 易迭代开发</p>
				</div>
				<div>
					<div class="top">
						<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/ziyan.png" alt="" />
						<h4>自研框架</h4>
					</div>
					<p>· 自主研发框架，安全稳定更强大</p>
					<p>· 封装多种常用开发模块</p>
					<p>· 提高开发效率</p>
					<p>· 多种模块，降低成本</p>
				</div>
				<div>
					<div class="top">
						<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/caiyong.png" alt="" />
						<h4>采用MVC模式</h4>
					</div>
					<p>· 视图层与业务层分离</p>
					<p>· 增强功能重用性</p>
					<p>· 减少开发周期</p>
					<p>· 便于系统维护和修改</p>
				</div>
				<div class="box">
					<div class="top">
						<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/kekao.png" alt="" />
						<h4>可靠性与安全性</h4>
					</div>
					<p>· 基于系统安全模块</p>
					<p>· 对传输数据加密</p>
					<p>· 校验、地址防注入、动态验证等多</p>
					<p>· 种方式保障系统安全</p>
				</div>
			</div>
		</div>
	</div>
	<div class="case">
		<h3>各行业场景化应用案例</h3>
		<div class="content">
			<img class="appkuang" src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/appkuang.png"
				alt="" />
			<!-- swiper -->
			<div class="swiper-container1">
				<div class="swiper-wrapper">
					<div class="swiper-slide">
						<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/ban01.png" alt="" />
					</div>
					<div class="swiper-slide">
						<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/ban02.png" alt="" />
					</div>
					<div class="swiper-slide">
						<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/appswiper3.png" alt="" />
					</div>
					<div class="swiper-slide">
						<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/appswiper4.png" alt="" />
					</div>
					<div class="swiper-slide">
						<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/ban03.png" alt="" />
					</div>
				</div>
				<div class="swiper-pagination"></div>
			</div>
		</div>
	</div>
	<div class="serve">
		<h3>上千企业的放心之选</h3>
		<p>同追求极致的机构合作，创造有影响力的产品</p>
		<div class="content">
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/bg1.png" alt="" class="bg" />
			<div class="dingzhi">
				<h3>小程序定制开发</h3>
				<p>企业移动信息化转型，互联网创业快速落地</p>
				<!-- <h5>400-039-7699</h5> -->
				<h5>15617622505</h5>
			</div>
		</div>
	</div>
	<div class="selfdom">
		<div class="content">
			<div class="left">
				<h3>1V1按需求个性化定制，全行业小程序解决方案</h3>
				<p>专业的解决方案、先进的产品帮您实现业务的快速增长</p>
			</div>
			<!-- <button @click="toConsult">在线咨询</button> -->
			<a onclick="openZoosUrl('chatwin')">在线咨询</a>
		</div>
	</div>
	<Footer></Footer>
	<Onlineservice></Onlineservice>
	<Floating></Floating>
</template>



<script>
	import "swiper/dist/js/swiper";
	import "swiper/dist/css/swiper.css";
	import Swiper from "swiper";
	import Nav from "../Nav.vue";
	import Footer from "../Footer.vue";
	import Floating from "../Floating.vue";
	import Onlineservice from "../Onlineservice.vue";
	export default {
		name: "HelloWorld",
		components: {
			Nav,
			Footer,
			Floating,
			Onlineservice
		},
		data() {
			return {
				isLogoShow: false,
				index: 0,
				isImgShow: true,
				pfstatus: 2,
			};
		},

		mounted() {
			this.$refs.Box.addEventListener("scroll", this.scroll);
			new Swiper(".swiper-container", {
				//direction: 'vertical', // 垂直切换选项
				//mousewheel: true, //滚轮
				autoplay: {
					//自动开始
					delay: 2500, //时间间隔
					disableOnInteraction: false, //*手动操作轮播图后不会暂停*
				},
				loop: true, // 循环模式选项
				//  一行显示多个
				slidesPerView: 4,
				// 4个为一组
				slidesPerGroup: 1,

				// 如果需要分页器
				// pagination: {
				// 	el: '.swiper-pagination1',
				// 	clickable: true, // 分页器可以点击
				// },

				// 如果需要前进后退按钮
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},

				// 如果需要滚动条
				// scrollbar: {
				// 	el: '.swiper-scrollbar',
				// },
			});

			new Swiper(".swiper-container1", {
				//direction: 'vertical', // 垂直切换选项
				//mousewheel: true, //滚轮
				autoplay: {
					//自动开始
					delay: 2500, //时间间隔
					disableOnInteraction: false, //*手动操作轮播图后不会暂停*
				},
				loop: true, // 循环模式选项
				//  一行显示多个
				slidesPerView: 5,
				// 4个为一组
				slidesPerGroup: 1,
				spaceBetween: 30,
				centeredSlides: true,

				// 如果需要分页器
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},

				// 如果需要前进后退按钮
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},

				// 如果需要滚动条
				// scrollbar: {
				// 	el: '.swiper-scrollbar',
				// },
			});
		},
		methods: {
			toConsult() {
				window.open(
					"https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn&e=%e5%bc%b9%e7%aa%97",
					"_blank"
				);
			},
			mouseOver(index) {
				this.isImgShow = true;
				this.index = index;
			},
			mousepiaofu(index) {
				this.pfstatus = index;
			},
			mouseLeave() {
				this.isImgShow = false;
			},

			toLeft() {
				this.$refs.Box.scrollLeft -= 360;
			},
			toRight() {
				this.$refs.Box.scrollLeft += 360;
				console.log(this.$refs.Box.scrollLeft);
			},
			toConsult() {
				window.open(
					"https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn&e=%e5%bc%b9%e7%aa%97",
					"_blank"
				);
			},
		},
	};
</script>

<style lang="less" scoped>
	// 1.50416
	.header {
		width: 100%;
		height: 650px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/homeBanner.png) no-repeat;
		background-size: cover;

		.content {
			width: 1440px;
			height: 400px;
			margin: 0 auto;
			/* background-color: white; */
			overflow: hidden;
			color: white;
			position: relative;

			h3 {
				height: 50px;
				line-height: 50px;
				font-size: 36px;
				margin-top: 100px;
				font-weight: 540;
			}

			p {
				height: 50px;
				line-height: 50px;
				font-size: 22px;
				margin-top: 20px;
				font-weight: 400;
			}

			a {
				display: block;
				width: 180px;
				height: 50px;
				text-align: center;
				line-height: 50px;
				margin-top: 40px;
				background: #fe0000;
				box-shadow: 0px 8px 32px 0px rgba(254, 0, 0, 0.16);
				border-radius: 25px;
				font-size: 16px;
				color: white;
			}
		}

		.ability {
			width: 1440px;
			height: 100px;
			margin: 0 auto;
			margin-top: 100px;
			// position: absolute;
			// left: 300px;

			div {
				display: flex;
				align-items: center;
				width: 250px;
				height: 100px;
				background-color: #f2f4fa;
				float: left;
				margin: 0 10px;
				transition: transform 0.5s;
				border-radius: 3px;
				box-shadow: 2px 2px 10px 2px #1b335a1a;
			}

			div:nth-child(1)>img,
			div:nth-child(3)>img {
				width: 60px;
				height: 30px;
				display: block;
				margin: 0 15px 0 20px;
			}

			div:nth-child(2)>img,
			div:nth-child(4)>img {
				width: 60px;
				height: 30px;
				display: block;
			}

			.piaofu {
				box-shadow: 2px 2px 2px 6px #fe000010;
				border-bottom: 2px solid #fe0000;
				transform: translateY(-10px);
			}

			p {
				height: 100px;
				line-height: 100px;
				font-size: 16px;
				font-weight: 500;
				color: #000000;
			}
		}
	}

	.serve1 {
		width: 100%;
		height: 920px;
		overflow: hidden;
		background: #f6f8fb;



		h3 {
			width: 100% !important;
			height: 50px;
			font-size: 36px;
			font-weight: 500;
			color: #000000;
			line-height: 50px;
			text-align: center;
			margin-top: 120px;
			margin-bottom: 57px;
		}

		.card {
			width: 1401px;
			margin: auto;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-wrap: wrap;
			position: relative;

			.card-bg {
				width: 1288px;
				height: 692px;
				position: absolute;
				right: -260px;
				top: -240px;
				z-index: 1;
			}

			.item {
				width: 336px;
				height: 190px;
				background: #FFFFFF;
				border-radius: 5px 5px 5px 5px;
				box-shadow: 4px 6px 34px 0px rgba(229, 28, 23, 0.1);
				text-align: center;
				margin-bottom: 19px;
				transition: all 0.5s;
				z-index: 100;

				img {
					width: 108px;
					margin-top: 20px;
				}

				h5 {
					font-size: 26px;
					font-weight: 500;
					color: #000000;
				}

				span {
					display: inline-block;
					width: 70px;
					height: 36px;
					background: #ffffff;
					border: 1px solid #e5e5e5;
					border-radius: 5px;
					font-size: 14px;
					font-weight: 400;
					color: #333333;
					line-height: 36px;
					text-align: center;
					margin: 18px 10px 0 0;
				}
			}

			.item:hover {
				transform: translateX(-5px) translateY(-5px);
			}
		}

		.content {
			width: 1440px !important;
			height: 640px;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 40px;

			.left {
				width: 470px;
				height: 620px;
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/leftbg.png) no-repeat;
				background-size: cover;
				overflow: hidden;

				h4 {
					width: 80%;
					height: 80px;
					font-size: 28px;
					font-weight: 500;
					color: #000000;
					line-height: 40px;
					margin: 0 auto;
					margin-top: 70px;
				}

				p {
					width: 80%;
					height: 32px;
					font-size: 16px;
					font-weight: 400;
					color: #666666;
					line-height: 32px;
					margin: 0px auto;
					margin-bottom: 10px;
					text-align: left;
				}

				.more {
					margin-top: 10px;
					width: 102px;
					height: 36px;
					padding: 6px 20px;
					border: 1px solid #fe070b;
					border-radius: 4px;
					font-size: 16px;
					font-weight: 500;
					color: #fe070b;
					line-height: 36px;
					text-align: center;
					margin: 40px 0 0 50px;
				}
			}

			.right {
				overflow: hidden;
				width: 950px;
				height: 600px;
				// background: #fe0000;
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				align-content: space-around;

				.box {
					width: 465px;
					height: 180px;
					background: #ffffff;
					display: flex;
					justify-content: space-around;
					align-items: center;
					border-radius: 6px;
					box-shadow: 5px 5px 10px 0px #0000000b;
					transition: all 0.5s;

					img {
						display: block;
						width: 60px;
						height: 60px;
						margin-left: 20px;
						margin-right: 10px;
					}

					.dians {
						width: 360px;
						height: 100px;
						overflow: hidden;

						h5 {
							width: 100%;
							height: 30px;
							font-size: 30px;
							font-weight: 500;
							color: #181818;
							line-height: 30px;
							margin-top: 10px;
						}

						span {
							display: inline-block;
							width: 70px;
							height: 36px;
							background: #ffffff;
							border: 1px solid #e5e5e5;
							border-radius: 5px;
							font-size: 14px;
							font-weight: 400;
							color: #333333;
							line-height: 36px;
							text-align: center;
							margin: 20px 10px 0 0;
						}
					}
				}

				.box:hover {
					background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/redBg.png) no-repeat;
					background-size: auto;
					transform: translateX(-5px) translateY(-5px);
					box-shadow: 8px 8px 5px 5px rgba(255, 162, 145, 0.2);

					h5 {
						color: #ffffff;
					}

					span {
						background: #ffffff8a;
						border: 1px solid #ffffff8a;
						color: #fff;
					}
				}
			}
		}
	}

	.major {
		width: 100%;
		height: 960px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/fuwubg.png) no-repeat;
		background-size: cover;
		overflow: hidden;

		h2 {
			width: 100%;
			height: 50px;
			font-size: 36px;
			font-weight: 500;
			color: #000000;
			line-height: 50px;
			text-align: center;
			margin-top: 60px;
		}

		.content {
			width: 1440px;
			margin: 0 auto;

			.swiper-container {
				width: 100%;
				height: 100%;
				overflow: hidden;

				.swiper-wrapper {
					width: 1440px;
					height: 600px;
					margin: 0 auto;
					margin-top: 50px;
					align-items: center;

					.swiper-slide {
						width: 330px;
						height: 443px;

						div {
							overflow: hidden;

							h3 {
								width: 200px;
								height: 50px;
								font-size: 26px;
								font-weight: 500;
								color: #ffffff;
								line-height: 50px;
								margin: 50px 0 0 30px;
							}

							.heng {
								width: 40px;
								height: 2px;
								background: #ffffff;
								margin: 10px 0 0 30px;
							}

							p {
								width: 300px;
								height: 16px;
								font-size: 16px;
								font-weight: 400;
								color: #ffffff;
								line-height: 58px;
								margin: 50px 0 0 30px;
							}
						}

						.ban1 {
							background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/swiper1.png) no-repeat;
							background-size: cover;
							width: 330px;
							height: 443px;
						}

						.ban2 {
							background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/swiper2.png) no-repeat;
							background-size: cover;
							width: 330px;
							height: 443px;
							margin-top: 80px !important;
						}

						.ban3 {
							background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/swiper3.png) no-repeat;
							background-size: cover;
							width: 330px;
							height: 443px;
						}

						.ban4 {
							background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/swiper4.png) no-repeat;
							background-size: cover;
							width: 330px;
							height: 443px;
							margin-top: 80px !important;
						}
					}
				}

				.swiper-button-next {
					background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/right.png) no-repeat;
					margin-top: 54px;
					margin-right: 16px;
				}

				.swiper-button-prev {
					background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/left.png) no-repeat;
					margin-top: 54px;
				}
			}
		}
	}

	.skill {
		width: 100%;
		height: 820px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/002.png) no-repeat;
		background-size: auto;

		.content {
			width: 1440px;
			height: 100%;
			margin: 0 auto;
			overflow: hidden;

			h3 {
				width: 500px;
				height: 50px;
				font-size: 40px;
				color: #000000;
				line-height: 50px;
				margin-top: 100px;
			}

			p {
				width: 500px;
				height: 30px;
				font-size: 16px;
				font-weight: 400;
				color: #333333;
				line-height: 30px;
				margin-top: 10px;
			}

			a {
				display: block;
				width: 126px;
				height: 50px;
				text-align: center;
				background: red;
				border-radius: 30px;
				font-weight: 500;
				color: #ffffff;
				line-height: 50px;
				font-size: 16px;
				margin-top: 60px;
			}

			.buttom {
				width: 1440px;
				height: 380px;
				overflow: hidden;
				display: flex;
				justify-content: space-around;
				// align-items: flex-end;
				margin-top: 100px;

				div {
					width: 350px;
					height: 350px;
					background: #ffffff;
					box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.011);
					overflow: hidden;

					.top {
						width: 260px;
						height: 100px;
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-left: 30px;
						margin-top: 20px;

						img {
							display: block;
							width: 36px;
							height: 36px;
						}

						h4 {
							width: 200px;
							height: 50px;
							font-size: 26px;
							font-weight: 500;
							color: #000000;
							line-height: 50px;
						}
					}

					p {
						margin-left: 30px;
					}
				}
			}
		}
	}

	.case {
		width: 100%;
		height: 920px;
		background: #f5f8fc;
		overflow: hidden;

		h3 {
			width: 100%;
			height: 50px;
			font-size: 36px;
			font-weight: 500;
			color: #000000;
			line-height: 50px;
			text-align: center;
			margin-top: 60px;
		}

		.content {
			position: relative;
			width: 1440px;
			height: 750px;
			overflow: hidden;
			margin: 0 auto;

			.appkuang {
				position: absolute;
				display: block;
				width: 287px;
				height: 580px;
				top: 78px;
				left: 575px;
				z-index: 999;
			}

			.swiper-container1 {
				position: relative;
				width: 100%;
				height: 100%;

				.swiper-pagination /deep/ .swiper-pagination-bullet {
					border-radius: 0px;
					width: 30px;
					height: 3px;
				}

				.swiper-pagination /deep/ .swiper-pagination-bullet-active {
					border-radius: 0px;
					width: 30px;
					height: 3px;
					background: #fe0202;
				}

				// background: rebeccapurple;
				.swiper-wrapper {
					width: 100%;
					height: 100%;
					align-items: center;

					.swiper-slide {
						width: 280px;
						height: 600px;
						overflow: hidden;
						display: -webkit-box;
						display: -ms-flexbox;
						display: -webkit-flex;
						display: flex;
						-webkit-box-pack: center;
						-ms-flex-pack: center;
						-webkit-justify-content: center;
						justify-content: center;
						-webkit-box-align: center;
						-ms-flex-align: center;
						-webkit-align-items: center;
						align-items: center;
						transition: 300ms;
						transform: scale(0.8);

						img {
							width: 100%;
						}
					}

					.swiper-slide-active,
					.swiper-slide-duplicate-active {
						transform: scale(1.08);
						border-radius: 100px;
					}

					.swiper-slide-prev,
					.swiper-slide-next {
						transform: scale(0.9);
					}
				}
			}
		}
	}

	.serve {
		width: 100%;
		height: 950px;
		overflow: hidden;
		background-color: #f2f6f9;

		h3 {
			width: 358px;
			height: 60px;
			margin: 0 auto;
			margin-top: 80px;
			text-align: center;
			line-height: 60px;
			font-size: 36px;
			font-weight: 500;
			color: #000000;
		}

		p {
			width: 358px;
			height: 50px;
			line-height: 50px;
			margin: 0 auto;
			margin-bottom: 50px;
			text-align: center;
			font-size: 16px;
			font-weight: 400;
			color: #000000;
		}

		.content {
			overflow: hidden;
			position: relative;
			width: 100%;
			height: 700px;

			.bg {
				display: block;
				margin: auto;
				width: auto;
				max-width: 100%;
				border: none;
				vertical-align: middle;
				overflow: hidden;
				transform: scale(1.2);
				transition: all 0.8s;
				transition-property: all;
				transition-duration: 0.8s;
				transition-timing-function: ease;
				transition-delay: 0s;
			}

			.bg:hover {
				transform: scale(1);
			}

			.dingzhi {
				display: block;
				position: absolute;
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/xcydzkfbg.png) no-repeat;
				background-size: cover;
				width: 788px;
				height: 444px;
				top: 0;
				right: 0;
				left: 0;
				bottom: 0;
				margin: auto;

				h3 {
					width: 100%;
					height: 40px;
					text-align: center;
					font-weight: 500;
					color: #ffffff;
				}

				p {
					width: 100%;
					height: 30px;
					font-size: 20px;
					font-weight: 400;
					color: #ffffff;
					line-height: 30px;
					text-align: center;
					margin-top: 20px;
				}

				h5 {
					width: 100%;
					height: 58px;
					font-size: 64px;
					font-weight: 400;
					color: #ffffff;
					line-height: 30px;
					text-align: center;
				}
			}
		}
	}

	.selfdom {
		width: 100%;
		height: 236px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/lanBg.png) no-repeat;
		background-size: cover;

		.content {
			width: 1440px;
			height: 100%;
			display: flex;
			justify-content: space-around;
			align-items: center;
			margin: 0 auto;

			.left {
				width: 800px;
				height: 200px;

				h3 {
					width: 800px;
					height: 50px;
					font-size: 36px;
					font-weight: 500;
					color: #ffffff;
					line-height: 50px;
					margin-top: 50px;
				}

				p {
					width: 450px;
					height: 30px;
					font-size: 18px;
					font-weight: 400;
					color: #ffffff;
					line-height: 30px;
					margin-top: 20px;
				}
			}

			a {
				display: block;
				width: 210px;
				height: 60px;
				background: rgba(255, 255, 255, 0.9);
				box-shadow: 10px 17px 20px 0px rgba(16, 16, 94, 0.1),
					0px 1px 0px 0px #ffffff;
				border-radius: 30px;
				font-size: 18px;
				font-weight: 500;
				line-height: 60px;
				text-align: center;
				color: #154484;
			}
		}
	}

	// swiper
</style>